import { toBool, fromBool, checkPercentage } from "views/Config/PolicyEdit/utils";

export const responsePolicyMap = {
  "Name:": {
    name: "name",
    valueF: function (value) {
      return value;
    },
  },
  "Blocking:": {
    name: "bckEnabled",
    valueF: function (value) {
      return toBool(value);
    },
  },
  "RatePerSubs downlink:": {
    name: "rateSubsDownEnabled",
    valueF: function (value) {
      return toBool(value);
    },
  },
  "RatePerSubs downlink: Rate:": {
    name: "shapdRate",
    valueF: function (value) {
      return (Number(value) / 1000).toFixed(3);
    },
  },
  "RatePerSubs downlink: Burst rate:": {
    name: "shapdBrate",
    valueF: function (value) {
      if (checkPercentage(value)) {
        return value;
        // return value.slice(0, value.length-1);
      }
      return (Number(value) / 1000).toFixed(3);
    },
  },
  "RatePerSubs downlink: Burst duration:": {
    name: "shapdBdur",
    valueF: function (value) {
      return Number(value);
    },
  },
  "RatePerSubs downlink: Burst threshold:": {
    name: "shapdBthr",
    valueF: function (value) {
      if (checkPercentage(value)) {
        return value;
      }
      return (Number(value) / 1000).toFixed(3);
    },
  },
  "RatePerSubs downlink: Burst threshold window:": {
    name: "shapdBthrw",
    valueF: function (value) {
      return Number(value).toFixed(0);
    },
  },
  "Flow limit:": {
    name: "shapdRateFlow",
    valueF: function (value) {
      return isNaN(value) ? value : Number(value);
    },
  },
  "Auto-Congestion-Management:": {
    name: "acmEnabled",
    valueF: function (value) {
      return value == "enabled" ? true : false;
    },
  },
  "RatePerSubs uplink:": {
    name: "rateSubsUpEnabled",
    valueF: function (value) {
      return toBool(value);
    },
  },
  "RatePerSubs uplink: Rate:": {
    name: "shapuRate",
    valueF: function (value) {
      return (Number(value) / 1000).toFixed(3);
    },
  },
  "RatePerSubs uplink: Burst rate:": {
    name: "shapuBrate",
    valueF: function (value) {
      if (checkPercentage(value)) {
        return value;
      }
      return (Number(value) / 1000).toFixed(3);
    },
  },
  "RatePerSubs uplink: Burst duration:": {
    name: "shapuBdur",
    valueF: function (value) {
      return Number(value);
    },
  },
  "RatePerSubs uplink: Burst threshold:": {
    name: "shapuBthr",
    valueF: function (value) {
      if (checkPercentage(value)) {
        return value;
      }
      return (Number(value) / 1000).toFixed(3);
    },
  },
  "RatePerSubs uplink: Burst threshold window:": {
    name: "shapuBthrw",
    valueF: function (value) {
      return Number(value).toFixed(0);
    },
  },
  "Source:": {
    name: "source",
    valueF: function (attrs) {
      return attrs;
    },
  },
};

export const DEFAULT_POLICY = {
  name: "",
  bckEnabled: false,
  acmEnabled: true,
  rateSubsDownEnabled: false,
  rateSubsUpEnabled: false,
  flowLimitEnabled: false,
  shapdRate: 100000,
  shapdBrate: 0,
  shapdBrateUnit: "mbps",
  shapdBdur: 0,
  shapdBthr: 0,
  shapdBthrUnit: "mbps",
  shapdBthrw: 300,
  shapuRate: 100000,
  shapuBrate: 0,
  shapuBrateUnit: "mbps",
  shapuBdur: 0,
  shapuBthr: 0,
  shapuBthrUnit: "mbps",
  shapuBthrw: 300,
  shapdRateFlow: 100000,
};
